import {
  SHOPCODE_CLOSE_POPUP,
  SHOPCODE_OPEN_SUCCESS,
  SHOPCODE_OPEN_FAIL,
  SHOPCODE_REQUEST,
} from "./types";

export const shopcodeClosePopup = () => {
  return {
    type: SHOPCODE_CLOSE_POPUP,
  };
};

export const shopcodeOpenSuccess = (message) => {
  return {
    type: SHOPCODE_OPEN_SUCCESS,
    payload: message,
  };
};

export const shopcodeOpenFail = (message) => {
  return {
    type: SHOPCODE_OPEN_FAIL,
    payload: message,
  };
};
export const shopcodeRequest = (payload) => {
  return {
    type: SHOPCODE_REQUEST,
    payload: payload,
  };
};
